import isNil from 'lodash/isNil';
import _has from 'lodash/has';
import { ChartSeries } from './index';
import type { IScatterChartSerData } from '@tencent/slide-sdk-model';
import type { SerRules } from './index';
import type {
    IScatterChartSeries,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart/scatter-chart.interface';

export class ScatterChartSeries extends ChartSeries implements IScatterChartSeries {
    // 是否是平滑线
    public smooth: boolean;
    public constructor(serData: IScatterChartSerData, options: SerRules) {
        super(serData, options);
        const { smooth } = serData;
        this.smooth = !!smooth?.val;
    }

    public setDataList(series: IScatterChartSerData, options: SerRules) {
        super.setDataList(series, options);

        this.dataList.forEach((uiDataItem) => {
            if (_has(uiDataItem, 'valuePoint.value') && !isNil(uiDataItem.valuePoint?.value)) {
                const numberValue = Number(uiDataItem.valuePoint!.value);
                if (!isNaN(numberValue)) {
                    uiDataItem.valuePoint!.value = numberValue;
                }
            }

            if (_has(uiDataItem, 'categoryPoint.value') && !isNil(uiDataItem.categoryPoint?.value) && uiDataItem.categoryPoint?.value !== '') {
                const numberValue = Number(uiDataItem.categoryPoint!.value);
                if (!isNaN(numberValue)) {
                    uiDataItem.categoryPoint!.value = numberValue;
                }
            }
        });
    }
}
